import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=2a5ba232&"
import script from "./InputPhone.vue?vue&type=script&lang=ts&"
export * from "./InputPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports